import React from 'react';
import { useParams } from 'react-router-dom';
import SelectField from './SelectField';
import useCompanyServices from '../../queries/useCompanyServices';

const ServicesSelectField = ({
  editingRoom,
  getPopupContainer,
  form,
  hasLabel = true,
}) => {
  const { getFieldDecorator } = form;

  const params = useParams();

  const { data: companyServices } = useCompanyServices(params.facilityId, {
    enabled: !editingRoom?.companyServices?.length,
  });

  return Boolean(companyServices?.length) ||
    editingRoom?.companyServices?.length ? (
    <SelectField
      label={hasLabel ? 'Услуги' : ''}
      name="companyServices"
      getFieldDecorator={getFieldDecorator}
      items={
        editingRoom?.companyServices
          ? editingRoom.companyServices
          : companyServices
      }
      options={{
        initialValue:
          editingRoom?.companyServices &&
          editingRoom.companyServices
            .filter((service) => service.isUse)
            .map((service) => service.id),
      }}
      selectProps={{
        placeholder: 'Выбрать из списка',
        mode: 'multiple',
        getPopupContainer,
      }}
      valueKey="id"
      getContent={(item) => item.shortName}
    />
  ) : null;
};

export default ServicesSelectField;
